import { Component, Input } from "@angular/core";

@Component({
  selector: "spinner-primary",
  templateUrl: "spinner.component.html"
})
export class SpinnerComponent {
  @Input() customstyle: any;
}
